import React, { useState } from 'react'

import PasswordInput from './PasswordInput';
import API_URL from '../components/ApiUrl'
import { useTranslation } from 'react-i18next';

const Form = ({ token, setFormDone, setTokenExpired }) => {
    const { t } = useTranslation();
    const [apiresponse, setApiResponse] = useState({
        loading: false,
        success: false,
        status: '',
        error: false
    });
    const [formInput, setFormInput] = useState({
        password: "",
        confirmPassword: "",
    });
    const [formError, setFormError] = useState({
        password: "",
        confirmPassword: "",
        response: "",
    });

    const handleUserInput = (name, value) => {
        setFormInput({
            ...formInput,
            [name]: value,
        })
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        let inputError = {
            password: "",
            confirmPassword: "",
            response: "",
        }

        let inputRespone = {
            loading: false,
            success: false,
            status: '',
            error: false
        }
        setApiResponse({
            ...inputRespone
        });
        if (!formInput.password) {
            setFormError({
                ...inputError,
                password: t('change_password.form.result.error.empty_password'),
            })
            return;
        }
        if (!/^(?=.*[0-9])(?=.*[a-zA-Z]).{8,}$/.test(formInput.password)) {
            setFormError({
                ...inputError,
                password: t('change_password.form.result.error.format'),
            })
            return;
        }

        if (formInput.confirmPassword !== formInput.password) {
            setFormError({
                ...inputError,
                confirmPassword: t('change_password.form.result.error.not_match'),
            })
            return;
        }
        setFormError(inputError);

        setApiResponse({
            ...apiresponse,
            loading: true
        });
        await fetch(`${API_URL}/users/reset-password`, {
            body: JSON.stringify({
                token: token,
                newPassword: formInput.password
            }),
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(function (response) {
                console.log(response);
                setApiResponse({
                    loading: false,
                    success: response.ok,
                    status: response.status,
                    error: response.status !== 200 ? true : false
                });
                if (response.ok) {
                    console.log(response.ok);
                    setFormDone(true);
                } else {
                    if (response.status === 401) {
                        setFormError({
                            ...inputError,
                            response: t('change_password.form.result.error.token_missing')
                        })
                    }
                    switch (response.status) {
                        case 401:
                            setFormError({
                                ...inputError,
                                response: t('change_password.form.result.error.token_missing')
                            })
                            break;
                        case 404:
                            setTokenExpired(true);
                            break;

                        default:
                            setFormError({
                                ...inputError,
                                response: t('change_password.form.result.error.api_other') + response.status
                            })
                            break;
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
                setApiResponse({
                    error: true,
                    loading: false,
                    status: error
                });
            });

    }

    return (
        <form onSubmit={handleSubmit} className='form'>
            <p className="label">{t('change_password.form.new_password.title')}</p>
            <PasswordInput name="password"
                type="password"
                onChange={({ target }) => handleUserInput(target.name, target.value)}
                value={formInput.password}
                placeholder={t('change_password.form.placeholder')}
            />
            <p className="error-message">{formError.password}</p>

            <p className="label">{t('change_password.form.repeat_password.title')}</p>
            <PasswordInput name="confirmPassword"
                onChange={({ target }) => handleUserInput(target.name, target.value)}
                value={formInput.confirmPassword}
                placeholder={t('change_password.form.placeholder')}
            />
            <p className="error-message">{formError.confirmPassword}</p>
            {apiresponse.success && <p className="success-message">{t('change_password.form.result.success')}</p>}
            <p className="error-message">{formError.response}</p>
            {/* {apiresponse.error && <p className="error-message">錯誤{apiresponse.status}</p>} */}
            <input className='submit' type="submit" value={t('change_password.form.btn')} disabled={apiresponse.loading || apiresponse.success} />
        </form>
    )
}

export default Form;